import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { OtherCodeResponse } from "@/Patient/Api/MedfarBilling/Dto/Responses/OtherCodeResponse";

interface IMedfarBillingAutoCompleteOtherCodeProps {
    serverOperation: ServerOperations.Server;
    onItemSelectCallBack: (item: OtherCodeResponse) => void;
    IsSpecialist: boolean;
    ClearCodeOnSelect: boolean;
    onCodeChange?: (code: string) => void;
}

interface IMedfarBillingAutoCompleteOtherCodeState {
    text: string;
    list: Immutable.List<OtherCodeResponse>;
}

class MedfarBillingAutoCompleteOtherCode extends BaseReactComponent<IMedfarBillingAutoCompleteOtherCodeProps, IMedfarBillingAutoCompleteOtherCodeState> {
    private timeoutReference: number = -1;
    private blurReference: number = -1;

    constructor(props: IMedfarBillingAutoCompleteOtherCodeProps) {
        super(props);

        this.state = {
            text: "",
            list: Immutable.List([])
        };
    }

    public render(): JSX.Element {
        return (
            <div className="fmp-autocomplete">
                <input type="text" onChange={(e: any) => this.onTextChange(e.target.value)} value={this.state.text} className="form-control" onFocus={(e: any) => this.handleTextFocus(e.target.value)} onBlur={() => this.onBlur()} />
                <div className="list-container-fmp">
                    {this.state.list.size > 0 && (
                        <div className="results-container" style={{ zIndex: 500, overflowY: "scroll", maxHeight: "350px" }}>
                            <ul className="results-list" style={{ width: "475px" }}>
                                {this.state.list.map(item =>
                                    <li key={item.Code}><div style={{ width: "460px", "whiteSpace": "nowrap", "overflow": "hidden", "textOverflow": "ellipsis" }}><a onClick={() => this.selectItem(item)} onMouseDown={() => this.selectItem(item)}>({item.Code}) {item.Description}</a></div></li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private onTextChange(code: string): void {
        this.props.onCodeChange?.(code);
        this.handleTextFocus(code);
    }

    private handleTextFocus(val: string): void {
        this.mutateState(s => s.text = val);

        clearTimeout(this.timeoutReference);
        this.timeoutReference = window.setTimeout(() => this.loadData(), 400);
    }

    private loadData(): void {
        if (this.state.text.trim().length < 2)
            return;

        const client = new Client();

        client.Post(
            this.props.serverOperation,
            { SearchText: this.state.text, IsSpecialist: this.props.IsSpecialist },
            response => {
                const model: OtherCodeResponse[] = response.OtherCodeList;
                this.mutateState(s => s.list = Immutable.List(model));
            },
            error => console.error(error)
        );
    }

    private selectItem(item: OtherCodeResponse): void {
        clearTimeout(this.blurReference);

        this.props.onItemSelectCallBack(item);

        this.mutateState(s => {
            s.text = this.props.ClearCodeOnSelect === true ? "" : item.Code;
            s.list = Immutable.List([]);
        });
    }

    private onBlur(): void {
        this.blurReference = window.setTimeout(() => this.mutateState(s => s.list = Immutable.List([])), 250);
    }
}

export { MedfarBillingAutoCompleteOtherCode };
